import { handleActions } from 'redux-actions'
import {
  SET_CURRENT_PAGE_DONE,
  SET_AUTH_TOKEN_DONE,
  SET_ACTIVE_CANDIDATE_ID_DONE,
  CONVERT_RESUMES_INIT,
  CONVERT_RESUMES_DONE,
  CONVERT_RESUMES_FAIL,
  UPDATE_CANDIDATE_TARGET_FILE_NAME,
} from '../actions/actions'
import $ from 'jquery'

export const conversionInProgress = handleActions(
  {
    [CONVERT_RESUMES_INIT]: (state, action) => {
      return true
    },
    [CONVERT_RESUMES_DONE]: (state, action) => {
      return false
    },
    [CONVERT_RESUMES_FAIL]: (state, action) => {
      return false
    },
  },
  false
)

export const currentPage = handleActions(
  {
    [SET_CURRENT_PAGE_DONE]: (state, action) => {
      return action.payload
    },
  },
  null
)

export const activeCandidateId = handleActions(
  {
    [SET_ACTIVE_CANDIDATE_ID_DONE]: (state, action) => {
      return action.payload
    },
  },
  null
)

export const authToken = handleActions(
  {
    [SET_AUTH_TOKEN_DONE]: (state, action) => {
      return action.payload
    },
  },
  null
)

export const targetFileNamesData = handleActions(
  {
    [UPDATE_CANDIDATE_TARGET_FILE_NAME]: (state, action) => {
      let nextState = $.extend(true, {}, state)
      const { candidateId, targetFileName } = action.payload
      if (candidateId) {
        nextState[`candidate_${candidateId}`] = targetFileName
      }
      return nextState
    },
  },
  {}
)
